
export default class DefaultRegion {
    "id": number;
    "regionName": string = "";
    "regionDescription": string = "";
} 